import React, { useContext, useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import CustomTag from './CustomTag';
import { Context } from '../context/AppContext';
import useOnScreen from '../hooks/useOnScreen';

const BackgroundImage = ({
  src,
  fallback,
  children,
  className,
  tag = 'div',
  ...props
}) => {
  const { webp } = useContext(Context);
  const ref = useRef();
  const onScreen = useOnScreen(ref);
  const [inView, setInView] = useState();

  useEffect(() => {
    if (onScreen) setInView(true);
    return () => {};
  }, [onScreen]);

  return (
    <CustomTag
      ref={ref}
      tag={tag}
      {...props}
      className={classNames({
        [className]: className,
      })}
      style={{
        ...(inView
          ? {
              ...(src || fallback
                ? { backgroundImage: `url(${webp ? src : fallback})` }
                : {}),
            }
          : {}),
      }}
    >
      {children}
    </CustomTag>
  );
};
export default BackgroundImage;
